import { FileUtils } from "../../../../../common/utils/file_utils";
import { IUpdateDocumentoUseCase } from "../../../presentation/useCases/update/update_documento_use_case";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

// UpdateEnderecoUseCase


export class UpdateDocumentoUseCase implements IUpdateDocumentoUseCase {
  constructor(
    private readonly repository: ITerceirizacaoRepository,
  ) { }

  async updateDocumento(
    idFuncionarioDocumento: number,
    arquivoNome: string | null,
    statusArquivo: number | null,
    nomeDocumento: string,
    dataVencimento: Date | null,
    arquivo: File | null,
    limparArquivo: boolean,
  ): Promise<void> {
    const computedArquivoNome = arquivo && !limparArquivo
      ? await this.getFilename(arquivo)
      : null;

    const computedArquivo = arquivo && !limparArquivo
      ? await this.convertToBase64(arquivo)
      : null;

    
    await this.repository.updateDocumento(
      idFuncionarioDocumento,
      nomeDocumento,
      statusArquivo,
      dataVencimento,
      computedArquivoNome,
      arquivo,
      limparArquivo,
    );
  }

  private async getFilename(file: File | null): Promise<string | null> {
    if (file === null) return null;
    return file.name;
  }

  private async convertToBase64(file: File | null): Promise<string | null> {
    return await FileUtils.readFileAsBase64(file);
  }
}
